export const GET_MODEL_LIST = 'GET_MODEL_LIST';
export const GET_TAG_LIST = 'GET_TAG_LIST';
export const MODEL_IS_LOADING = 'MODEL_IS_LOADING';